import { render } from "./TopHeader.vue?vue&type=template&id=ec518150"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=ec518150&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__